import React from "react";

function Footer() {
  return (
    <div id="App-footer" className="app-footer app-hdr-footer-common highlight-font"><span>myDineStein</span></div>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer.js